import { render, staticRenderFns } from "./posPassword.vue?vue&type=template&id=5638d142&scoped=true&"
import script from "./posPassword.vue?vue&type=script&lang=js&"
export * from "./posPassword.vue?vue&type=script&lang=js&"
import style0 from "./posPassword.vue?vue&type=style&index=0&id=5638d142&prod&lang=less&"
import style1 from "./posPassword.vue?vue&type=style&index=1&id=5638d142&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5638d142",
  null
  
)

export default component.exports